var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1917.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Chat",
    transform: "translate(445.000000, 1917.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,12 C21.896,12 21,11.104 21,10 C21,8.896 21.896,8 23,8 C24.104,8 25,8.896 25,10 C25,11.104 24.104,12 23,12 L23,12 Z M16,12 C14.896,12 14,11.104 14,10 C14,8.896 14.896,8 16,8 C17.104,8 18,8.896 18,10 C18,11.104 17.104,12 16,12 L16,12 Z M9,12 C7.896,12 7,11.104 7,10 C7,8.896 7.896,8 9,8 C10.104,8 11,8.896 11,10 C11,11.104 10.104,12 9,12 L9,12 Z M4,0 C1.791,0 0,1.791 0,4 L0,21 L0.001,21 L0.002,32 L0.324,32 C2.359,32 3.672,30.841 4.984,28.79 L9.696,21 L28,21 C30.209,21 32,19.209 32,17 L32,0 L4,0 Z",
    id: 183
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionChat);
export default __webpack_public_path__ + "static/media/navigation-and-action-chat.7601a3ab.svg";
export { ForwardRef as ReactComponent };